// Responsive utilities adapted from original app

const BASE_WIDTH = 375 // iPhone X width as base
const BASE_HEIGHT = 812 // iPhone X height as base

export const responsiveAdapter = (
  size: number,
  currentWidth?: number,
): number => {
  const screenWidth =
    currentWidth ??
    (typeof window !== 'undefined' ? window.innerWidth : BASE_WIDTH)
  return Math.round((size * screenWidth) / BASE_WIDTH)
}

export const responsiveAdapterVertical = (
  size: number,
  currentHeight?: number,
): number => {
  const screenHeight =
    currentHeight ??
    (typeof window !== 'undefined' ? window.innerHeight : BASE_HEIGHT)
  return Math.round((size * screenHeight) / BASE_HEIGHT)
}

export const responsiveValueAdapter = (
  value?: number,
  isVertical = false,
  currentWidth?: number,
  currentHeight?: number,
): number | undefined => {
  if (value === undefined) return undefined
  return isVertical
    ? responsiveAdapterVertical(value, currentHeight)
    : responsiveAdapter(value, currentWidth)
}

export const responsiveMarginValueAdapter = (
  value?: number,
  isVertical = false,
  currentWidth?: number,
  currentHeight?: number,
): number | undefined => {
  if (value === undefined) return undefined
  return isVertical
    ? responsiveAdapterVertical(value, currentHeight)
    : responsiveAdapter(value, currentWidth)
}
